<template>
  <div v-if="title || page_bread_crumbs?.length > 0" class="flex items-center justify-between px-3 py-2 pr-4 h-14">
    <div class="flex items-center justify-between w-full min-w-0">
      <h1 class="pl-1.5 capitalize text-lg font-medium leading-6 dark:text-dark-body-text text-gray-900 whitespace-nowrap">
        {{ title }}
      </h1>
      <nav class="flex justify-between w-full">
        <ol class="flex items-center flex-1 ml-3">
          <li
            v-for="(bread, index) in page_bread_crumbs"
            :key="bread?.id || bread"
            :class="{ 'cursor-pointer': bread?.onClick }"
            @click="bread?.onClick ? bread.onClick() : void null">
            <div class="flex items-center">
              <ChevronRight
                v-if="!page_bread_crumbs[index - 1]?.hide_arrow && !(index == 0 && isPageTitleHidden)"
                class="flex-shrink-0 w-5 h-5 text-gray-400"
                aria-hidden="true" />
              <component :is="bread.component" v-if="bread.is_component" class="w-5 h-5 text-common-grey" />

              <div :class="[bread.object_type ? 'text-lg' : '', 'ml-2 text-sm font-medium capitalize text-gray-500 hover:text-gray-700']">
                {{ getBreadCrumbLabel(bread) }}
              </div>
            </div>
          </li>
        </ol>
      </nav>
      <slot name="right_menu" />
    </div>
  </div>
</template>

<script>
import { ChevronRight } from "lucide-vue-next"

export default {
  components: {
    ChevronRight
  },
  inject: ["getPageTabs"],
  props: {
    pageReference: {
      type: String,
      required: true
    },
    pageBreadCrumb: {
      type: Array,
      default: null,
      required: false
    },
    currentTab: {
      type: String,
      default: null,
      required: false
    },
    currentTemplate: {
      type: Object,
      default: null,
      required: false
    },
    selectedJourney: {
      type: Object,
      default: null,
      required: false
    },
    isPageTitleHidden: {
      type: Boolean,
      default: false
    },
    pageTitle: {
      type: String,
      default: null,
      required: false
    }
  },
  data() {
    return {
      breads: []
    }
  },
  computed: {
    title() {
      if (this.isPageTitleHidden) {
        return ""
      } else {
        if (this.pageTitle) {
          return this.pageTitle
        } else if (this.pageReference) {
          if (this.pageReference.includes("prospecting_")) {
            return this.pageReference.replace("prospecting_", "").replace("_", " ")
          } else if (this.pageReference.includes("customer_journeys")) {
            return this.selectedJourney?.name
          } else if (this.pageReference == "forecasting") {
            return "Forecasting"
          } else {
            return this.$route.params?.object_type || this.pageReference.replace("_profile", "")
          }
        }
        return ""
      }
    },
    page_bread_crumbs() {
      return this.pageBreadCrumb || this.breads
    }
  },

  watch: {
    currentTab() {
      if (this.currentTab) {
        let name = this.$store.state.ui.currentCompany?.name

        // let object_name_metric_reference = utils.getMetricById(this.$store.state.integration.platform_metric_mappings.find((m) => m.option == "name" && m.object_type == this.$store.state.ui.currentCompany?.type)?.metric)?.reference_name
        // if (object_name_metric_reference) {
        //   name = this.$store.state.ui.currentCompany.values[object_name_metric_reference]
        // }

        if (name) {
          this.breads = [name, this.currentTab]
        } else {
          this.breads = [this.currentTab]
        }
      } else {
        this.breads = null
      }
    }
  },
  methods: {
    getBreadCrumbLabel(bread) {
      return bread.label || bread.id || bread
    }
  }
}
</script>
